<template>
    <div>
        <TextBanner>
            <p> In der ukrainischen <strong>Sperrzone von Tschernobyl</strong> brennt seit Wochen der radioaktiv verseuchte Wald. Bisher konnten die Rettungskräfte das Feuer vom <strong>Kernkraftwerk</strong> abwenden und damit auch von <strong>Reaktorblock 4.</strong></p>
        </TextBanner>

        <InfoBox modalName="HotspotSperrzone">
            <template #title>Brände um das Atomkraftwerk </template>
            <template #subline></template>
            <template>
                <FullscreenImage v-bind:src="'img/1a_foto_1_thumb.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/1a_foto_1.jpg" alt="">
                        <figcaption>&copy;dpa</figcaption>
                    </figure>
                </FullscreenImage>
                <p>In den vergangenen Jahren kam es mehrfach zu Feuern in den unbesiedelten Gebieten der Sperrzone. Als Ursache gilt oft Brandstiftung. </p>
                <p>Umweltschutzorganisationen warnen vor radioaktivem Staub, der durch die Brände aufgewirbelt wird. Winde tragen die Staubwolken bis in die 70 Kilometer entfernte ukrainische Hauptstadt Kiew. Hier wurde bereits erhöhte Radioaktivität gemessen. </p>
            </template>
        </InfoBox>

        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/00_Sperrzone_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/00_Sperrzone_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <!--<img class="o-fit o-fit--cover" src="../assets/img/fallback/TextBanner.jpg" alt="">-->
                <img class="o-fit o-fit--cover" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="">
            </picture>
        <div class="hotspot" v-on:click="infobox('HotspotSperrzone')"></div>	
        </Fallback>
    </div>

    
</template>

<script>
    export default {
        name: 'Sperrzone',
        babylonState: {
            moveCamera: [-7.5, 1.1,50,5,0,-5],
            hotspot: {
                visible: true,
                infoBox: 'HotspotSperrzone', // Muss zur Infobox oben passen!
                position: [13, 10, 50],
                //scale: 0,
                scale: 30,
            },

            Geo_Tschernobyl: {
                children: {
                    BG_Sphere: true,

                    Geo_Neuer_Sarkophag_endpos: true,
                    Geo_Schattenplane_NSC: true,

                    Geo_KleinerTurm_Geruest1: true,
                    Geo_KleinerTurm_RoteStreifen1: true,
                    Geo_KleinerTurm_Schlot1: true,
                    Geo_KleinerTurm_Schattenplane: true,

                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,

                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,

                    Geo_GrosserTurm_Gestaenge1: false,
                    Geo_GrosserTurm_Schlot1: false,
                    Geo_GrosserTurm_RoteStreifen1: false,
                    Geo_GrosserTurm_Schattenplane: false,

                    Geo_Sperrzone: true,
                    Geo_Text_Sperrzone: true,


                },
            },

            fire: false,
        },
        babylonReady: function () {
            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);
            this.$audioController.initTrack('background', require('./../assets/audio/Geigerzaehler.mp3'), true, false),
            this.$babylonController.setCameraRadiusLimit (6,150),
            this.$babylonController.zoomCamera(1.5)
            
        },
    }
</script>

<style lang="scss">

</style>